/**
 * Accessory slot 1 of three. Trinkets, pouches and dosimeters: worn gear that shifts a stat or
 * carries a small plate rather than covering a hit location outright.
 */

import type { EquipmentSlot } from '@/sim/inventory/slotContract';

export const ACCESSORY_1_SLOT = {
  id: 'accessory1',
  label: 'Accessory 1',
  description: 'Worn gear that is not a plate: pouches, filters and charms.',
} as const satisfies EquipmentSlot;
